import React from "react";
import Logo from "./Logo";

// Splash / loading screen
export default function Splash({ message = "Bismillah..." }) {
  return (
    <div
      className="dnya-pattern"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--dnya-bg)",
        color: "var(--dnya-text)",
        padding: 24,
        textAlign: "center",
      }}
    >
      <Logo size={96} />
      <div className="font-dnya dnya-reveal dnya-reveal-d1" style={{ fontSize: 36, color: "var(--dnya-high-1)", marginTop: 20, letterSpacing: "0.08em" }}>
        Dnya
      </div>
      <div className="font-arabic dnya-reveal dnya-reveal-d2" style={{ fontSize: 26, color: "var(--dnya-high-2)", marginTop: 6 }}>
        دنيا
      </div>
      <div className="font-arabic dnya-reveal dnya-reveal-d3" style={{ fontSize: 18, color: "var(--dnya-high-1)", marginTop: 18, opacity: 0.9 }}>
        بِسْمِ اللهِ الرَّحْمٰنِ الرَّحِيْمِ
      </div>
      <div className="dnya-reveal dnya-reveal-d4" style={{ marginTop: 28, fontSize: 13, color: "var(--dnya-text-muted)" }}>
        {message}
      </div>
      <div style={{ marginTop: 24, width: 200, height: 3, background: "var(--dnya-bg-2)", borderRadius: 99, overflow: "hidden" }}>
        <div
          style={{
            height: "100%",
            background: "var(--dnya-high-1)",
            animation: "dnya-bar 1.4s ease-in-out infinite",
            transformOrigin: "left",
          }}
        />
      </div>
    </div>
  );
}
